<template>
  <div class="home">
  </div>
</template>

<script>
export default {
  name: 'Home',

  beforeCreate() {
    window.location.href = 'https://www.amtamassage.org/find-massage-school/'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue